<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Device Groups</h1>
                <div v-if="user.type === 'admin'">
                    <v-btn color="black" prepend-icon="mdi-plus" @click="createDialogSwitch = true">Add</v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th-btn :sortedColumn="sortedColumn" column="label" sortable title="Group Name"
                                @sort="sort"/>
                        <th-btn :sortedColumn="sortedColumn" column="label" sortable title="Total Devices"
                                @sort="sort"/>
                        <th v-if="user.type === 'admin'">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="group in device_groups" v-if="!loading && device_groups.length" :key="group.id"
                        class="text-left">
                        <!--						<td>
                                                    <v-icon
                                                        :color="(group.current_status && group.current_status.voltage1)?(sku.current_status.voltage1>3.4?'green':'orange'):'red'"
                                                        icon="mdi-circle"/>
                                                </td>-->
                        <td>{{ group.label }}</td>
                        <td>{{ group.devices_count }}</td>
                        <td v-if="user.type === 'admin'">
                            <v-btn-group
                                density="compact"
                                divided
                                variant="outlined"
                            >
                                <v-btn :disabled="!group.devices_count" class="text-dark"
                                       prepend-icon="mdi-mail"
                                       size="x-small" @click="sendMessage(group)">Send Message
                                </v-btn>
                                <v-btn class="text-dark" prepend-icon="mdi-plus"
                                       size="x-small" @click="linkDeviceGroup(group)">Device
                                </v-btn>

                                <v-btn :disabled="editDialogSwitch" class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editDeviceGroup(group)">Edit
                                </v-btn>
                                <v-btn class="text-error" prepend-icon="mdi-delete" size="x-small"
                                       @click="deleteDeviceGroup(group)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" colspan="10">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="7">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>
        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @update:model-value="fetchDeviceGroups"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
    <CreateGroup v-if="user.type === 'admin' && createDialogSwitch"
                 v-model="createDialogSwitch"
                 @addDeviceGroup="addDeviceGroup"/>

    <EditGroup v-if="editDialogSwitch" v-model="editDialogSwitch"
               :deviceGroup="selectedDeviceGroup"
               @updateDeviceGroup="updateDeviceGroup"/>

    <GroupDevice v-if="assignDialogSwitch"
                 v-model="assignDialogSwitch"
                 :deviceGroup="selectedDeviceGroup"
                 @newDevices="fetchDeviceGroups"/>

    <message-create-edit v-if="messageDialogSwitch"
                         v-model="messageDialogSwitch"
                         :device-group="selectedDeviceGroup"/>

</template>
<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import ThBtn from "@/components/globals/th-btn.vue";
import {useSnackbarStore} from "@/stores/snackBarStore";
import CreateGroup from "@/components/dialogs/devices/group/Create.vue";
import EditGroup from "@/components/dialogs/devices/group/Edit.vue";
import GroupDevice from "@/components/dialogs/devices/group/GroupDevice.vue";
import MessageCreateEdit from "@/components/dialogs/devices/commands/Create_Edit.vue";

const device_groups = ref([]);
const {user} = useAuthStore();
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const totalDevices = ref(0);
const sortedType = ref(null);
const sortedColumn = ref(null);
const device_counts = ref([]);
const selectedDeviceGroup = ref(null);
const {showSnackbar} = useSnackbarStore();
const editDialogSwitch = ref(false);
const createDialogSwitch = ref(false);
const assignDialogSwitch = ref(false);
const messageDialogSwitch = ref(false);

onMounted(() => {
    fetchDeviceGroups();
});

const sort = (sorting) => {
    sortedColumn.value = sorting.column;
    sortedType.value = sorting.order;
    fetchDeviceGroups();
}

const linkDeviceGroup = (group) => {
    assignDialogSwitch.value = true;
    selectedDeviceGroup.value = group;
}
const sendMessage = (group) => {
    selectedDeviceGroup.value = group;
    messageDialogSwitch.value = true;
}
const fetchDeviceGroups = () => {
    let data = {
        page: currentPage.value,
        order: sortedType.value,
        sort: sortedColumn.value,
    };
    loading.value = true;
    send('get', `device-groups`, data)
        .then((response) => {
            device_groups.value = response.data.data.device_groups.data;
            totalDevices.value = response.data.data.device_groups.total;
            totalPages.value = response.data.data.device_groups.last_page;
            currentPage.value = response.data.data.device_groups.current_page;
            device_counts.value = response.data.data.device_counts;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Devices group could not be loaded', 'error')
        })
}
const addDeviceGroup = (sku) => {
    device_groups.value.unshift(sku);
}
const editDeviceGroup = (group) => {
    selectedDeviceGroup.value = group;
    editDialogSwitch.value = true;
}
const updateDeviceGroup = (sku) => {
    device_groups.value.map((item, index) => {
        if (item.id === sku.id) {
            device_groups.value[index] = sku;
        }
    });
}
const deleteDeviceGroup = (group) => {
    if (confirm(`Are you sure to delete "${group.label}" device group?`)) {
        send('delete', `device-groups/${group.id}`)
            .then((response) => {
                if (response.data.success) {
                    device_groups.value.map((dev, index) => {
                        if (dev.id === group.id) {
                            device_groups.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error)
                showSnackbar(`"${group.lable}" Device group could not be deleted`, 'error')
            })
    }
}
</script>
